declare global {
  interface Window {
    dataLayer: any[];
    [key: string]: any;
  }
}

// 允许的域名列表
const ALLOWED_DOMAINS = ['ai.laigu.com'];

// 防止重复初始化
let isGTMInitialized = false;

// GTM 核心加载逻辑
const loadGTM = () => {
  if (isGTMInitialized) return;
  isGTMInitialized = true;

  // Initialize GTM
  (function (w: Window, d: Document, s: string, l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-MB6JS4PL');

  // Add noscript iframe
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-MB6JS4PL';
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
};

/**
 * 延迟初始化 GTM，避免影响首屏性能
 * 策略：在浏览器空闲时或页面加载完成后 2 秒加载
 */
export const initGTM = () => {
  if (
    import.meta.env.DEV ||
    !ALLOWED_DOMAINS.some((domain) => window.location.hostname.endsWith(domain))
  ) {
    return;
  }

  // 使用 requestIdleCallback 在浏览器空闲时加载
  // 如果浏览器不支持，则在页面加载完成后 2 秒加载
  const win = window as typeof window & {
    requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
  };

  if (typeof win.requestIdleCallback === 'function') {
    win.requestIdleCallback(
      () => {
        loadGTM();
      },
      { timeout: 3000 }, // 最多 3 秒后强制执行
    );
  } else {
    // 备用方案：页面加载完成后延迟加载
    const delayedLoad = () => setTimeout(loadGTM, 2000);

    if (document.readyState === 'complete') {
      delayedLoad();
    } else {
      win.addEventListener('load', delayedLoad);
    }
  }
};
